import { Avatar, CardHeader, ThemeProvider, Typography } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import MuiStylesCustomCardHeader from "~/components/common/customCardHeader/MuiStylesCustomCardHeader";
import MuiThemeCustomCardHeader from "~/components/common/customCardHeader/MuiThemeCustomCardHeader";
import { useResponsiveText } from "~/hooks/useResponsiveText";

const CustomCardHeader = ({business, backgroundDefault}) => {
	const classes = MuiStylesCustomCardHeader();
	const photos = business?.photos;
	const textSize = useResponsiveText({ title: 20 });

	const coverPhoto = () => {
		if (!business?.photos[0]) return false;
		const found = photos.find((photo) => photo.order === 1) || photos[0];
		return found.url;
	};

	const getInitials = (businessName) => {
		if (!businessName) return "";
		return businessName
			.split(" ")
			.filter(Boolean)
			.slice(0, 2)
			.map(word => word[0].toUpperCase())
			.join("");
	}

	return (
		<ThemeProvider theme={MuiThemeCustomCardHeader}>
			<div style={{display:"flex", justifyContent:"center",flexDirection:"column"}}>
				<Avatar
					variant="circle"
					style={{
						height: "100px",
						width: "100px",
						alignSelf: "center",
						backgroundColor: "#8C1837"
					}}
					src={business?.thumbnailUrl ? business.thumbnailUrl : ""}
				>
					<Typography style={{ fontSize: 46 }}>
						{business?.thumbnailUrl ? business.thumbnailUrl : getInitials(business?.name)}
					</Typography>
				</Avatar>
				<Typography
					className={clsx({ [classes.title]: true, [classes.titleWithoutBackground]: !!!business?.photos[0]?.url })}
					style={{ color: `${backgroundDefault ? '#222' : '#fff'}`, fontSize: textSize?.title}}
					variant="h5"
					component="h1">
					{business?.name ? business.name : ""}
				</Typography>
			</div>
		</ThemeProvider>
	);
};

export default CustomCardHeader;
